module.exports = __webpack_public_path__ + "static/img/23.43b863ec.jpg";